/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/jsx-no-target-blank */
import { scope, sendCodeTimeKey } from '@/config/base';
import { getLocalStorage, setLocalStorage } from '@/utils/cookies';
import { MailOutlined, MobileOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import { sendPhoneCode } from '../../http';
import { validIsMobile } from '../../utils';
import SubmitButton from '../SubmitButton';
import styles from './index.less';

const { useForm } = Form;
const sendCodeTimeOut = 60;

type SmsLoginProps = {
  /** 平台名称 */
  platformName?: string;
  /** 白色背景 */
  white?: boolean;
  /** 登录回调 */
  onLogin?: (val: { channel: string; credentials: string }, bol?: boolean) => void;
  /** 用户服务名称 */
  serviceText?: string;
  /** 隐私协议名称 */
  privacyText?: string;
  /** 服务协议 */
  serviceProtocolUrl?: string;
  /** 隐私协议 */
  privacyProtocolUrl?: string;
  /** 是否展示协议 */
  protocolBool?: boolean;
};

/** 手机短信登录 */
const SmsLogin: React.FC<SmsLoginProps> = (props) => {
  const {
    onLogin,
    platformName,
    white,
    protocolBool,
    serviceProtocolUrl,
    serviceText,
    privacyProtocolUrl,
    privacyText,
  } = props;
  const [form] = useForm();

  const [phoneNo, setPhoneNo] = useState('');
  const [canSendCode, setCanSendCode] = useState(true);
  const [canLogin, setCanLogin] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const onFinish = async (values: any) => {
    console.log('Success:', values);
    setCanLogin(true);
    onLogin && onLogin({ channel: 'phone', scope, ...values });
    // try {
    //   const token: any = await doLogin({ channel: 'phone', scope, ...values });
    //   onLogin && onLogin({ channel: 'phone', credentials: values.phone });
    //   setToken(token);
    // } finally {
    //   console.log('登录失败');
    // }
  };

  const validPhoneNo = (rule: any, value: any) => {
    if (value === '') {
      return Promise.reject('手机号码不能为空');
    }
    if (!validIsMobile(value)) {
      return Promise.reject('手机号格式不正确');
    }
    return Promise.resolve();
  };

  const agreementValid = (rule: any, val: any) => {
    return val ? Promise.resolve() : Promise.reject();
  };

  const getErrorMessage = () => {
    const errors = form.getFieldsError();
    let errorMessage: string[] = [];
    errors.forEach((item) => {
      errorMessage = errorMessage.concat(item.errors);
    });
    const errorMsg = errorMessage.reverse().pop();
    errorMsg && message.error(errorMsg);
    console.log(errors);
  };

  const handleSendSmsCode = async () => {
    if (!phoneNo) {
      message.error('手机号码不能为空');
      return;
    }
    try {
      await sendPhoneCode(phoneNo);
      setLocalStorage(sendCodeTimeKey, Date.now());
      setTimeLeft(sendCodeTimeOut);
      setCanSendCode(false);
    } finally {
      console.log(1);
    }
  };

  useEffect(() => {
    const time = getLocalStorage(sendCodeTimeKey);
    if (time) {
      const timeLeftData = Math.floor((Date.now() - time) / 1000);
      const isCan = timeLeftData > sendCodeTimeOut;
      setCanSendCode(isCan);
      if (!isCan) {
        setTimeLeft(sendCodeTimeOut - timeLeftData);
      }
    }
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      setCanSendCode(false);
      setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 900);
    } else {
      setCanSendCode(true);
    }
  }, [timeLeft]);

  return (
    <Form
      name="basic"
      form={form}
      style={{ width: 310 }}
      size="large"
      onFinish={onFinish}
      onFinishFailed={getErrorMessage}
      autoComplete="off"
    >
      <Form.Item name="phone" noStyle rules={[{ validator: validPhoneNo }]}>
        <Input
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          autoComplete="new-password"
          maxLength={11}
          placeholder="输入登录手机"
          prefix={<MobileOutlined />}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
      </Form.Item>

      <Form.Item name="captcha" noStyle rules={[{ required: true, message: '验证码不能为空' }]}>
        <Input
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          prefix={<MailOutlined style={{ fontSize: 14 }} />}
          suffix={
            <Button
              type="link"
              size="small"
              style={{ fontSize: 16 }}
              disabled={!canSendCode || !validIsMobile(phoneNo)}
              onClick={() => handleSendSmsCode()}
            >
              {canSendCode ? '获取验证码' : `${timeLeft}s后重新获取`}
            </Button>
          }
          placeholder="输入短信验证码"
          autoComplete="off"
        />
      </Form.Item>

      <Form.Item noStyle wrapperCol={{ span: 24 }}>
        <div style={{ marginBottom: protocolBool ? 263.5 : 24 }} />
      </Form.Item>

      {protocolBool ? (
        <Form.Item
          noStyle
          name="protocol"
          valuePropName="checked"
          wrapperCol={{ span: 24 }}
          rules={[
            {
              validator: agreementValid,
              message: '请先阅读勾选服务条款与隐私协议',
            },
          ]}
        >
          <div style={{ marginBottom: 16 }}>
            <Checkbox className={`${styles['small-font']}`}>阅读并同意{platformName}</Checkbox>
            <a
              href={serviceProtocolUrl || ''}
              className={`${styles['small-font']} ${styles.protocol}`}
              target="_blank"
            >
              {serviceText || '服务协议'}
            </a>
            <span className={styles['small-font']}> 和 </span>
            <a
              className={`${styles['small-font']} ${styles.protocol}`}
              href={privacyProtocolUrl || ''}
              target="_blank"
            >
              {privacyText || '隐私协议'}
            </a>
          </div>
        </Form.Item>
      ) : null}

      <Form.Item wrapperCol={{ span: 24 }}>
        {/* <Button
          className={`${styles['custom-btn']} ${!canLogin ? styles.disabled : ''}`}
          type="primary"
          htmlType="submit"
          size="large"
          block
        >
          登录
        </Button> */}
        <SubmitButton
          form={form}
          label="登录"
          buttonProps={{ type: 'primary', size: 'large', block: true }}
        />
      </Form.Item>
    </Form>
  );
};

export default SmsLogin;
